__turbopack_context__.v({
  "digital-magazine-embed": "UoZfwG_digital-magazine-embed",
});
